import * as localForage from "localforage";

interface StorageItem {
    key: string;
    data: any;
}
export const storeData = async (title: string, item: StorageItem) => {
    // create store instance
    let store = localForage.createInstance({
        name: title
    });

    // put the data
    //TODO :: store the key/value ::  LOCALFORAGE CACHE FAVORITES
    try {
        return await store.setItem( item.key, item.data)
    } catch (error) {
        return {error};
    }
};

export const getData = async (title: string, key: string) => {
    let store = localForage.createInstance({
        name: title
    });

    try {
        return await store.getItem(key)

    } catch (error) {
        return {error};
    }
};

export const removeData = async (title: string, key: string) => {
    let store = localForage.createInstance({
        name: title
    });

    try {
        await store.removeItem(key)
        return {message: "success"}
    } catch (error) {
        return {error};
    }
};

export const deleteCache = (title: string) => {
    localForage.dropInstance({
        name: title
    });
}